import React, { RefObject } from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import s from './Highlights.scss';
import Package from './Package';
import { TypeSelectedOffer } from '../../types/general-types';
import { isLocalJapanese } from '../../services/window-utils';
import { ClientOffering } from '../../services/client-offering';
import { PRODUCT } from '../Mobile/mobile-constant';
import classnames from 'classnames';
import ArrowDown from 'wix-ui-icons-common/ArrowDown';

export interface HighlightsProps extends WithTranslation {
  onScrollToCompare: Function;
  data: ClientOffering;
  selectedOffer: TypeSelectedOffer;
}

class Highlights extends React.Component<HighlightsProps> {
  scrollRef: RefObject<HTMLDivElement> = React.createRef();

  render() {
    const { t, data, selectedOffer } = this.props;
    const priceCurrency =
      new DOMParser().parseFromString(data.currency.symbol, 'text/html').body
        .textContent || '$';

    const shouldShowTaxInPrice = data.currency.taxType;

    return (
      <div className={s.strip} data-hook="highlights-strip">
        <div
          ref={this.scrollRef}
          className={classnames(s.root, { [s.leftToRight]: isLocalJapanese() })}
          data-hook="highlights"
        >
          <Package
            mostPopular={false}
            currentPlan={false}
            packageName={t('package.free.name')}
            packageSlogan={t('package.free.slogan')}
            packageFree={true}
            selectedOffer={selectedOffer}
            productId=""
            productIndex={PRODUCT.FREE}
            taxType={data.currency.taxType}
            isSaleOn={!!data.isSaleOn()}
          />
          <Package
            mostPopular={false}
            currentPlan={data.currentProduct?.productIndex === 0}
            packageName={t('package.basic.name')}
            packageSlogan={t('package.basic.slogan')}
            packageFree={false}
            priceAmount={
              shouldShowTaxInPrice
                ? data.products[0].priceWithTax
                : data.products[0].price
            }
            discountAmount={
              shouldShowTaxInPrice
                ? data.products[0].cycles[1].discountedPriceWithTax
                : data.products[0].cycles[1].discountedPrice
            }
            priceCurrency={priceCurrency}
            cycles={data.products[0].cycles}
            selectedOffer={selectedOffer}
            productId={data.products[0].productId}
            isEnabled={data.products[0].isEnabled}
            productIndex={PRODUCT.BASIC}
            taxType={data.currency.taxType}
            isCTAPrimary={false}
            isSaleOn={!!data.isSaleOn()}
          />
          <Package
            mostPopular={
              data.currentProduct?.productIndex === 1 ||
              !data.currentProduct?.productIndex
            }
            currentPlan={data.currentProduct?.productIndex === 1}
            packageName={t('package.professional.name')}
            packageSlogan={t('package.professional.slogan')}
            packageFree={false}
            priceAmount={
              shouldShowTaxInPrice
                ? data.products[1].priceWithTax
                : data.products[1].price
            }
            discountAmount={
              shouldShowTaxInPrice
                ? data.products[1].cycles[1].discountedPriceWithTax
                : data.products[1].cycles[1].discountedPrice
            }
            priceCurrency={priceCurrency}
            cycles={data.products[1].cycles}
            selectedOffer={selectedOffer}
            productId={data.products[1].productId}
            isEnabled={data.products[1].isEnabled}
            productIndex={PRODUCT.PRO}
            taxType={data.currency.taxType}
            isCTAPrimary={data.products[1].isEnabled}
            isSaleOn={!!data.isSaleOn()}
          />
          <Package
            mostPopular={false}
            currentPlan={data.currentProduct?.productIndex === 2}
            packageName={t('package.unlimited.name')}
            packageSlogan={t('package.unlimited.slogan')}
            packageFree={false}
            priceAmount={
              shouldShowTaxInPrice
                ? data.products[2].priceWithTax
                : data.products[2].price
            }
            discountAmount={
              shouldShowTaxInPrice
                ? data.products[2].cycles[1].discountedPriceWithTax
                : data.products[2].cycles[1].discountedPrice
            }
            priceCurrency={priceCurrency}
            cycles={data.products[2].cycles}
            selectedOffer={selectedOffer}
            productId={data.products[2].productId}
            isEnabled={data.products[2].isEnabled}
            productIndex={PRODUCT.UNLIMITED}
            taxType={data.currency.taxType}
            isCTAPrimary={!data.products[1].isEnabled}
            isSaleOn={!!data.isSaleOn()}
          />
        </div>
        <div className={s.compareLink}>
          <div
            onClick={() => this.props.onScrollToCompare()}
            className={s.compareButton}
            data-hook="compare-link"
          >
            {t('package.compare')}
          </div>
          <div className={s.compareButton}>
            <ArrowDown onClick={() => this.props.onScrollToCompare()} />
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Highlights);
